import { BaseRequestResult } from "../../lib/request";
import {
  createQuestionnaireDraftSavedBase,
  QuestionnaireDraftSavedBase,
} from "../../model/questionnaire_draft";
import { ITask } from "../../shared/db";

// What a real questionnaire save tells the recovery copy it finishes (`confirmQuestionnaireDraftSaveStage`).

// No answer says whether the request landed: a network failure, a timeout or a 5xx
export const questionnaireDraftSaveIsAmbiguous = (
  result: Pick<BaseRequestResult, "statusCode">,
): boolean => result.statusCode === null || result.statusCode >= 500;

// The saved task a save's content stage produced, for a checkpoint should a later stage fail. A reply
// too unlike a task to fingerprint still names the task, with a base no saved task will match, so a
// restore treats it as changed and asks rather than quietly replacing it.
export const questionnaireDraftCheckpointOf = (
  task: ITask | null | undefined,
): { taskId: string; base: QuestionnaireDraftSavedBase } | undefined => {
  if (!task?.id) return undefined;
  try {
    return { taskId: task.id, base: createQuestionnaireDraftSavedBase(task) };
  } catch {
    return {
      taskId: task.id,
      base: { taskUpdatedAt: String(task.updatedAt ?? ""), fingerprint: "" },
    };
  }
};
